import { FontIcon, Stack } from "@fluentui/react";
import { domUtils, logger } from "cayo.ui";
import React from "react";
import styled from "styled-components";
import ajax from "@cayo/shared/libs/ajax";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import { RenderCellFn } from "./types";

const log = logger.getLogger("renderFavoriteQueryCell");

export const renderFavoriteQueryCell: RenderCellFn = ({ column, item, auxProps }) => {
  if (column.renderOptions?.formatter !== "favoriteQuery") {
    return null;
  }

  // log.debug("render -> onItemClicket", onItemClicked);

  const theme = auxProps?.theme;
  const value: boolean = !!item[column.fieldName ?? ""];

  return (
    <Stack
      styles={{ root: { cursor: "pointer" } }}
      verticalAlign="center"
      horizontalAlign="center"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!item.objectPath) {
          log.error("The object path is not set");
          return;
        }
        const url = endpoints.buildRelativeApiPath(item.objectPath);
        log.debug("onItemClick -> url", url);
        ajax
          .getClient(url, "PATCH", undefined, {
            isFavorite: !value,
          })
          .then((pathcResult) => {
            log.debug("onItemClick -> pathcResult", pathcResult);
            //TODO: refactor it
            auxProps?.additionalProps.dispatch({
              kind: "refresh",
              hideLoading: true,
              keepSelection: true,
            });
          })
          .catch((err) => {
            log.error("onItemClick -> error", err);
          });
      }}
      onMouseDown={domUtils.stopMouseDown}
    >
      <StyledFontIcon
        style={{
          color: value ? theme!.cayoTheme.brandColors.warning : "inherit",
        }}
        className={value ? "" : "cs-ShowOnHover"}
        iconName={value ? "FavoriteStarFill" : "FavoriteStar"}
      />
    </Stack>
  );
};

const StyledFontIcon = styled(FontIcon)`
  margin-top: 3px;
`;
